module.exports = __webpack_public_path__ + "img/2.68cc35e7.jpg";